import { render, staticRenderFns } from "./building.vue?vue&type=template&id=0d5e8376&scoped=true"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e8376",
  null
  
)

export default component.exports